import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import PlanSection from "../Components/PlanSection";
import { url, header } from "../Constent/Constant";

function PackingAndUnpacking() {
  const [PackingData, setPackingData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState("");
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [UpdateId, setUpdateId] = useState("");
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, []);

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Packing and UnPacking"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setPackingData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject);
    if (DataObject !== "") {
      fetch(`${url}/page/updatedata`, {
        method: "POST",
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text,
        }),
        headers: header,
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.message === "Success") {
            UpdateData();
          }
        });
    }
  };

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append("image", DataObject.image);
    Imagedata.append("id", DataObject.id);

    fetch(`${url}/page/updateimage`, {
      method: "POST",
      body: Imagedata,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.message === "Success") {
          UpdateData();
        }
      });
  };

  const handleCancel = () => {
    setTextModalVisible(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id);
  };

  const TextHandle = () => {
    if (HeadingUpdate === "") {
      message.error("Fill the Field");
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId,
      });
      setTextModalVisible(false);
      setHeadingUpdate("");
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate;
    console.log(a);
    if (event.key === "Enter") {
      console.log("Enter Clicked");
      a.concat("\n");
      setHeadingUpdate(a);
    } else {
      console.log(event.key);
    }
  };

  return (
    <Layout>
      {PackingData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: PackingData.section1image1._id,
          headingId: PackingData.section1heading1._id
        }}
        Image={PackingData.section1image1.image} />}

      <div className='Packing-Container'>
        <h2> {PackingData ? PackingData.section2heading1.content : 'No Text'}
          <i onClick={() => ShowTextModal(PackingData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <p> {PackingData ? PackingData.section2paragraph1.content : 'No Text'}
          <i onClick={() => ShowTextModal(PackingData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
        </p>
      </div>

      {PackingData && <PlanSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        CardData={{
          Card1: {
            img: PackingData.section3image1.image,
            imgId: PackingData.section3image1._id,
            heading: PackingData.section3heading1.content,
            headingId: PackingData.section3heading1._id,
            para: PackingData.section3paragraph1.content,
            paraId: PackingData.section3paragraph1._id,
          },
          Card2: {
            img: PackingData.section3image2.image,
            imgId: PackingData.section3image2._id,
            heading: PackingData.section3heading2.content,
            headingId: PackingData.section3heading2._id,
            para: PackingData.section3paragraph2.content,
            paraId: PackingData.section3paragraph2._id,
          },
          Card3: {
            img: PackingData.section3image3.image,
            imgId: PackingData.section3image3._id,
            heading: PackingData.section3heading3.content,
            headingId: PackingData.section3heading3._id,
            para: PackingData.section3paragraph3.content,
            paraId: PackingData.section3paragraph3._id,
          },
          Card4: {
            img: PackingData.section3image4.image,
            imgId: PackingData.section3image4._id,
            heading: PackingData.section3heading4.content,
            headingId: PackingData.section3heading4._id,
            para: PackingData.section3paragraph4.content,
            paraId: PackingData.section3paragraph4._id,
          },
          Card5: {
            img: PackingData.section3image5.image,
            imgId: PackingData.section3image5._id,
            heading: PackingData.section3heading5.content,
            headingId: PackingData.section3heading5._id,
            para: PackingData.section3paragraph5.content,
            paraId: PackingData.section3paragraph5._id,
          },
          Card6: {
            img: PackingData.section3image6.image,
            imgId: PackingData.section3image6._id,
            heading: PackingData.section3heading6.content,
            headingId: PackingData.section3heading6._id,
            para: PackingData.section3paragraph6.content,
            paraId: PackingData.section3paragraph6._id,
          }
        }} />}

      <div className='Packing-Section'>
        <h2> {PackingData ? PackingData.section4heading1.content : 'No Text'}
          <i onClick={() => ShowTextModal(PackingData.section4heading1._id)} className="far fa-edit Edit-btn"></i>
        </h2>
        <div className='Btn-Div'>
        <a href='tel: 844-346-2264 '> <button className='Button Call-btn'>CALL US (844)-346-2264 </button></a>
          <button className='Secondary-btn Button'>GET A QUOTE</button>
        </div>
      </div>

      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

    </Layout>
  );
}

export default PackingAndUnpacking;
